import * as constants from '@config/constants';

const initialState = {};

const reducer = (state = initialState, action) => {
  const xhrMeta = Object.assign({}, state[action.key]);
  switch (action.type) {
    case constants.XHR_IN_PROGRESS:
      xhrMeta.isLoading = true;
      return { ...state, [action.key]: xhrMeta };
    case constants.XHR_COMPLETE:
      xhrMeta.isLoading = false;
      xhrMeta.ts = Date.now();
      return { ...state, [action.key]: xhrMeta };
    default:
      return state;
  }
};

export default reducer;
